import Api from "@/config/Api";

export default {
  getUserInfoLegal(data) {
    return Api().post("u/info-legal", data);
  }
};
